export default "__VITE_ASSET__HeMVbH8R__"